<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Note on Translation and Transliteration</a></p><a id="page_vii">
<p class="noindent"><span class="small">ALL TRANSLATIONS FROM SPANISH ARE MINE, UNLESS OTHER</span>wise noted. I did not translate into English the Hebrew names of the organizations I discuss in the book, unless it was necessary to convey to the reader the type of work the organization engaged in. In most cases, the names chosen by the societies—most taken from biblical phrases—did not indicate the nature of the work carried out. I believe this approach preserves the language choices these Jewish Argentines made for the names of their societies. When transliterating Hebrew terms, I have generally followed the Library of Congress system, unless a different spelling was used as the legal name of an organization. In such cases, I retained the original spelling because in the early twentieth century there were no standard transliteration systems; rather, ad hoc solutions were employed, using Latin letters to attempt Hebrew pronunciation for Spanish speakers. Thus using a modern transliteration system would have meant that, in most cases, the names in this book would look very different from the ones these Argentine Jews used. Finally, I have chosen <i>Sephardi</i> over <i>Sephardic</i>, which sounded closer to the Hebrew and Spanish oral rendition of the same word.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Fm02.vue?4691eab4